import React from 'react';
import Performance from './Performance/Performance'
import FrequentlyTraded from './FrequentlyTraded/FrequentlyTraded'
import TradingProgressChart from './TradingProgressChart/TradingProgressChart'
import Copiers from './Copiers/Copiers'
import AverageRisk from './AverageRisk/AverageRisk'

const Stats = (isDarkMode) => {
    
    return (
        <div className='StatsContainar'
            style={{
                height: "100%",
                marginin: "1%",
                margin: "15px",
                width: "95%"

            }}>
            <Performance isDarkMode={isDarkMode} />
            <div style={{ width: "100%", display: "flex" }}>
                <AverageRisk />
                <Copiers />
            </div>
            <TradingProgressChart />
            <FrequentlyTraded />
        </div>
    )
}

export default Stats;